import {DateTime} from 'luxon';

export default function AggregateNotificationsByDateAndSymbols(notifications, dateFormatLocale) {

    const latestMap = new Map();

    for (let notification of notifications) {
        let {
            datetime, title, sourceName, tags, symbols, categories,
        } = notification;

        let orderedSymbols = symbols.map(s => s.symbol).sort((a, b) => a.localeCompare(b)).join(',');
        const dateString = DateTime.fromISO(datetime).toFormat('yyyy-MM-dd');

            const key = `${orderedSymbols}_${dateString}`;
            const existing = latestMap.get(key);

            if (!existing) {
                latestMap.set(key, Object.assign({
                    symbols,
                    date: dateString,
                    count: 0,
                    allSources: [sourceName],
                    allCategories: [...categories],
                    allTags: [...tags],
                }, notification));
            } else {
                existing.count += 1;
                existing.allSources = Array.from(new Set([...existing.allSources, sourceName]));
                existing.allCategories = Array.from(new Set([...existing.allCategories, ...categories]));
                existing.allTags = Array.from(new Set([...existing.allTags, ...tags]));

                // Keep the latest title + datetime
                if (new Date(datetime) > new Date(existing.datetime)) {
                    existing.title = title;
                    existing.datetime = datetime;
                }
        }
    }

    let aggregatedNotifications = Array.from(latestMap.values());
    let dates = {}
    aggregatedNotifications.forEach(notifcation => {

        const dateString = notifcation.date || DateTime.fromISO(notifcation.datetime).setLocale(dateFormatLocale).toFormat('yyyy-MM-dd');
        const dateFormat = notifcation.date ? DateTime.fromFormat(notifcation.date, 'yyyy-MM-dd').setLocale(dateFormatLocale).toFormat('DD') : DateTime.fromISO(notifcation.datetime).setLocale(this.dateFormatLocale).toFormat('DD');

        if (!dates[dateString]) {
            dates[dateString] = {
                date: dateString,
                format: dateFormat,
                news: []
            };
        }

        dates[dateString].news.push(notifcation);
    });

    return Object.values(dates);
}
